'use es6';

import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { HAS_USED_HUBSPOT } from '../constants/queryParamConstants';
import { OPS_HUB_INTEREST, SURVEY_KEYS } from '../constants/surveyConstants';
import { createOpsHubOnboardingKey } from '../utils/onboardingKeyUtils';
import { HubletUrl } from '../utils/urls';
const opsExperiencesChecks = [{
  redirectPath: (portalId, auth, survey) => {
    const opsHubOnboardingKey = createOpsHubOnboardingKey(survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.OPS,
      onboardingKey: opsHubOnboardingKey
    };
  },
  checks: [{
    survey: {
      crmExperience: HAS_USED_HUBSPOT,
      hubInterest: OPS_HUB_INTEREST
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const opsHubOnboardingKey = createOpsHubOnboardingKey(survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    return {
      url: `${HubletUrl.getAppUrl()}/ops-hub-demo/${portalId}?flowId=free`,
      view: ONBOARDING_VIEWS.OPS,
      onboardingKey: opsHubOnboardingKey
    };
  },
  checks: [{
    survey: {
      hubInterest: OPS_HUB_INTEREST
    }
  }]
}];
export default opsExperiencesChecks;